// Shared support and help-center actions for web, mobile and extension.
import modules from "@/store/index.js";
import { openExternalUrl } from "@/platform/browser.js";
import { clearSupportSession } from "@/services/support.services.js";
import articles from "@/constants/support-articles.json";
const displaySupportChat = () => modules.dispatch("support/open");
const displayHelpCenter = () =>
  openExternalUrl("https://vetalfa.com/articles/", { inAppBrowser: true });
const displayHelpArticle = id => {
  const slug = articles[String(id)];
  openExternalUrl(
    slug
      ? `https://vetalfa.com/articles/${id}-${slug}`
      : "https://vetalfa.com/articles/",
    { inAppBrowser: true }
  );
};
const shutdownSupport = () => {
  clearSupportSession();
  modules.dispatch("support/close");
};
export {
  displaySupportChat,
  displayHelpCenter,
  displayHelpArticle,
  shutdownSupport
};
